export const SET_PRODUCT_DATA = 'SET_PRODUCT_DATA';
export const SET_CHECK_LIST = 'SET_CHECK_LIST';
export const SET_IS_RK = 'SET_IS_RK';
